/**
 * 矿实体
 */
export interface OreEntity {
    uniqueId : string;//唯一id
    goodsId : number;
    name : string;//名称
    level : number;//等级 1
    type : number;//类型 1
    weight : number;//权重
    imgPath : string;//图片路径
    simpleDesc ?: string;//描述
    locationArray ?: { x : number , y : number }[];//坐标位置数组
}
/**
 *
 * @constructor
 */
export default function OreConfig() {
    let dataList : OreEntity[] = [
        {
            uniqueId : "1",
            goodsId : 11100,
            name :"花岗岩",
            level : 1 ,
            type : 1,
            weight : 20,
            imgPath : "花岗岩",
            simpleDesc : "普通到不能再普通的石头,就和你一样普通",
        },
        {
            uniqueId : "2",
            goodsId : 11102,
            name :"翡翠矿",
            level : 1 ,
            type : 1,
            weight : 15,
            imgPath : "翡翠矿",
            simpleDesc:"表面看起来是块普通的石头，其实可能就是一块普通的石头",
        },
        {
            uniqueId : "3",
            goodsId : 11104,
            name :"萤石矿",
            level : 1 ,
            type : 1,
            weight : 15,
            imgPath : "萤石矿",
            simpleDesc:"里面藏有稀有的萤石，是村里的主要收入来源",
        },
        {
            uniqueId : "4",
            goodsId : 11105,
            name :"白玉矿",
            level : 2 ,
            type : 1,
            weight : 15,
            imgPath : "白玉矿",
            simpleDesc:"这么丑的石头会开出白玉吗？"
        },
        {
            uniqueId : "5",
            goodsId : 11106,
            name :"火山石",
            level : 2 ,
            type : 1,
            weight : 20,
            imgPath : "火山石",
            simpleDesc:"火山喷发时形成的矿石。很大几率开出好东西哦",
        },
        {
            uniqueId : "6",
            goodsId : 11109,
            name :"黄斑玉石",
            level : 3 ,
            type : 1,
            weight : 5,
            imgPath : "黄斑玉石",
            simpleDesc:"好像能看到玉皮，会有惊喜吗？"
        },
        {
            uniqueId : "7",
            goodsId : 11113,
            name :"水晶矿",
            level : 3 ,
            type : 1,
            weight : 5,
            imgPath : "水晶矿",
            simpleDesc : "一闪一闪亮晶晶,大块的水晶矿石"
        },
        {
            uniqueId : "8",
            goodsId : 11114,
            name :"彩虚琨",
            level : 4 ,
            type : 1,
            weight : 5,
            imgPath : "彩虚琨",
            simpleDesc : "黄昏见证虔诚的信徒，巅峰诞生虚伪的拥护"
        }
    ];
    return dataList;
}

export interface OreSelectEntity{
    //Id
    id:string,
    //矿洞名字
    name:string,
    //描述
    explain:string,
    //配置表信息
    configs:OreEntity[],
    //显示的图片
    spPath:string
    //需要的钱
    needCoin:number,
}

let oreSelectEntityAry:OreSelectEntity[] = null;

export function OreSelectEntityConfig(){
    if(!oreSelectEntityAry){
        oreSelectEntityAry = [
            {id:"1",name:"一号矿洞",explain:"这是一号矿坑",configs:OreConfig(),spPath:"",needCoin:1000},
            {id:"2",name:"二号矿洞",explain:"这是二号矿坑",configs:OreConfig(),spPath:"",needCoin:5000},
            {id:"3",name:"三号矿洞",explain:"这是三号矿坑",configs:OreConfig(),spPath:"",needCoin:10000}
        ]
    }
    return oreSelectEntityAry;
}






